import Vue from 'vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

Vue.component('font-awesome-icon', FontAwesomeIcon);

import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faBell,
  faFile,
  faCopy,
  faServer,
  faTimes,
  faBuilding,
  faStream,
  faPen,
  faUserTie,
  faAddressBook,
  faClipboard,
  faGavel,
  faCoffee,
  faMoneyBill,
  faCloudUploadAlt,
  faArrowUp,
  faClock,
  faCalendar,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faTrash,
  faCrosshairs,
  faBoxes,
  faMapMarkerAlt,
  faPlus,
  faBars,
  faReceipt,
  faSearch,
  faCog,
  faUserFriends,
  faPercentage,
  faChartBar,
  faPaperclip,
  faMoneyCheck,
  faFileAlt,
  faCommentAlt,
  faStar,
  faCheck,
  faLandmark,
  faUser,
  faFileSignature,
  faEnvelope,
  faMailBulk,
  faCalendarAlt,
  faSync,
  faMinus,
  faImage,
  faTimesCircle,
  faSpinner,
  faExclamationCircle,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faTable,
  faUpload,
  faPlusCircle,
  faFilter,
  faUserPlus,
  faDownload,
  faPrint,
  faCheckCircle,
  faFileInvoice,
  faFileInvoiceDollar,
  faInfoCircle,
  faBan,
  faFilePdf,
  faFileAudio,
  faWallet,
  faEye,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faDollarSign,
  faUndo,
  faQuestionCircle,
  faHistory,
  faQrcode,
  faFileVideo,
  faUsers,
  faList,
  faBox,
  faBoxOpen,
  faEllipsisV,
  faPhoneAlt,
  faTruck,
  faTh,
  faLock,
  faLockOpen,
  faCalculator,
  faFlag,
  faRedo,
  faArchive,
  faGlobeEurope,
  faColumns,
  faEdit,
  faSave,
  faTabletAlt,
  faCheckSquare,
  faCamera,
  faListAlt,
  faPaperPlane,
  faRecycle,
  faQuestion,
  faExclamation,
  faChevronCircleDown,
  faSignOutAlt,
  faNewspaper,
  faHeart,
  faLightbulb,
  faReply,
  faExchangeAlt,
  faBook,
  faSort,
  faToggleOn,
  faToggleOff,
  faLanguage,
  faCreditCard,
  faMagic,
  faBolt,
  faExpand,
  faCompress,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
  faCcJcb,
  faCcDinersClub,
  faCcApplePay,
  faCcAmazonPay,
  faCcPaypal,
} from '@fortawesome/free-brands-svg-icons'
import { faSquare } from '@fortawesome/free-regular-svg-icons'

library.add(
  faSort,
  faReply,
  faLightbulb,
  faExchangeAlt,
  faTabletAlt,
  faRedo,
  faCalculator,
  faBox,
  faBoxOpen,
  faWallet,
  faList,
  faUsers,
  faMailBulk,
  faBell,
  faCopy,
  faFileAudio,
  faFileVideo,
  faQrcode,
  faHistory,
  faDollarSign,
  faQuestionCircle,
  faUndo,
  faEye,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faWallet,
  faMoneyBill,
  faFilePdf,
  faBan,
  faFileInvoice,
  faPrint,
  faDownload,
  faUserPlus,
  faFilter,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faExclamationCircle,
  faSpinner,
  faTimesCircle,
  faImage,
  faMinus,
  faSync,
  faMailBulk,
  faCalendarAlt,
  faEnvelope,
  faFileSignature,
  faUser,
  faLandmark,
  faCheck,
  faCommentAlt,
  faStar,
  faMoneyCheck,
  faFileAlt,
  faPaperclip,
  faChartBar,
  faPercentage,
  faServer,
  faPlus,
  faTimes,
  faBuilding,
  faStream,
  faPen,
  faUserTie,
  faAddressBook,
  faServer,
  faClipboard,
  faGavel,
  faTrash,
  faCloudUploadAlt,
  faCoffee,
  faArrowUp,
  faClock,
  faCalendar,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faCrosshairs,
  faBoxes,
  faMapMarkerAlt,
  faBars,
  faReceipt,
  faSearch,
  faCog,
  faUserFriends,
  faPlusCircle,
  faPlusCircle,
  faUpload,
  faTable,
  faCheckCircle,
  faFileInvoice,
  faFileInvoiceDollar,
  faInfoCircle,
  faFile,
  faMailBulk,
  faUsers,
  faList,
  faWallet,
  faEllipsisV,
  faPhoneAlt,
  faTruck,
  faTh,
  faLock,
  faLockOpen,
  faFlag,
  faArchive,
  faGlobeEurope,
  faColumns,
  faEdit,
  faSave,
  faPercentage,
  faCheckSquare,
  faSquare,
  faCamera,
  faListAlt,
  faPaperPlane,
  faRecycle,
  faQuestion,
  faExclamation,
  faChevronCircleDown,
  faSignOutAlt,
  faNewspaper,
  faHeart,
  faToggleOn,
  faToggleOff,
  faBook,
  faLanguage,
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
  faCcJcb,
  faCcDinersClub,
  faCcApplePay,
  faCcAmazonPay,
  faCcPaypal,
  faCreditCard,
  faMagic,
  faBolt,
  faExpand,
  faCompress,
);
